const size_matrix = {
	'bassinet': {
		name: 'Bassinet',
		slug: 'bassinet',
		width: 100,
		height: 70,
	},
	'cot': {
		name: 'Cot',
		slug: 'cot',
		width: 150,
		height: 90,
	},
};

const fontMatrix = {
  // 'Bebas':     'bebasregular',
  // 'GoodDog':  'gooddogregular',
  // 'Impact':    'Impact',
  // 'Quicksand': 'quicksandregular',
  // 'Quintus':   'quintus-bold',
  
  'Bebe':   'bebasregular',
  'Goodie': 'gooddogregular',
  'Impact': 'Impact',
  'Sandy':  'quicksandregular',
  'Quinty': 'quintus-bold',
};


//note: some colors adjusted for better screen representation! mainly, darkening light colors
const color_matrix = {
    'pale-pink':	'rgb(236 199 208)', //original: '#f2e3ef',
	'fawn':			'#cec2b1',
	'oatmeal':		'rgb(224 219 201)', //original: '#e6dec8',
	'pale-grey':	'#e3e3e3',
	'mid-grey':		'#9e9e9f',
    'pale-blue':	'rgb(182, 216, 221)', //original: '#e1f3f5',
	'mint':			'#d0f7e8',
	'mauve':		'#dac4e0',
	'lemon':		'#fff9ba',
	'forest':		'#3e8869',
	'tangerine':	'#ff8f60',
    'aqua':			'#1091af', //original: '#3594ac',
	'white':		'#ffffff',
	'black':		'#000000',
	'pink':			'#ff99ff',
    'navy':			'rgb(0 0 109)', //original: '#000099',
	'green':		'#00b300',
	'light-grey':	'#9e9e9e',
	'red':			'#e60000',
	'orange':		'#ff6600',
	'charcoal':		'#424245',
	'purple':		'#7956b0',
    'french-navy': '#6e6e82',
};

const color_matrix_text = {
    'pale-pink':	'#fed7e5', //'rgb(236 199 208)', //original: '#f2e3ef',
	'fawn':			'#cfb99b', //'#cec2b1',
	'oatmeal':		'#cac2ad', //original: '#e6dec8',
	'pale-grey':	'#e3e3e3',
	'mid-grey':		'#9e9e9f',
    'pale-blue':	'#c8d7e4', //original: '#e1f3f5',
	'mint':			'#baeae7', //'#d0f7e8',
	'mauve':		'#dac4e0',
	'lemon':		'#ffe670', //'#fff9ba',
	'forest':		'#005038', //'#3e8869',
	'tangerine':	'#ff8f60',
    'aqua':			'#007191', //original: '#3594ac',
	'white':		'#ffffff',
	'black':		'#000000',
	'pink':			'#e668af', //original: '#ff99ff',
    'navy':			'#a7cdd2', //original: '#000099',
	'green':		'#00b300',
	'light-grey':	'#9e9e9e',
	'red':			'#a80019', //original: '#e60000',
	'orange':		'#ff6600',
	'charcoal':		'#424245',
	'purple':		'#7956b0',
    'french-navy': '#6e6e82',
};

const color_matrix_text_darker = {
    'pale-pink':	'#f7b7c4', //'rgb(236 199 208)', //original: '#f2e3ef',
	'fawn':			'#8b8481', //'#cec2b1',
	'oatmeal':		'#c3bba4', //original: '#e6dec8',
	'pale-grey':	'#e3e3e3',
	'mid-grey':		'#5f5f61', //'#9e9e9f',
    'pale-blue':	'#b6cce2', //original: '#e1f3f5',
	'mint':			'#d0f7e8',
	'mauve':		'#dac4e0',
	'lemon':		'#fff9ba',
	'forest':		'#005038', //'#3e8869',
	'tangerine':	'#ff8f60',
    'aqua':			'#007191', //original: '#3594ac',
	'white':		'#ffffff',
	'black':		'#000000',
	'pink':			'#ff99ff',
    'navy':			'#001139', //original: '#000099',
	'green':		'#00b300',
	'light-grey':	'#9e9e9e',
	'red':			'#a80019', //original: '#e60000',
	'orange':		'#ff6600',
	'charcoal':		'#424245',
	'purple':		'#7956b0',
  'french-navy': '#6e6e82',
};

const design_matrix = {
    'retro-circles': {
      orientation: 'landscape',
      font: 'quicksandregular',
      sizes: {
        'bassinet': {
          font_size: 6.5,
          text_x: 50.25,
          text_y: 53.75
        },
        'cot': {
          font_size: 6.5,
          text_x: 50,
          text_y: 53.25
        }
      },
      darker_text_variants: [
        'pale-blue-and-navy',
      	'oatmeal-and-fawn',
        'white-and-pale-pink',
        'white-and-pale-blue',
        'white-and-pale-oatmeal',
      ]
	},
    'love-tree': {
      orientation: 'landscape',
      font: 'gooddogregular',
      sizes: {
        'bassinet': {
          font_size: 9.5,
          // text_x: 50.5, //pixel plot-matched
          // text_y: 59 //pixel plot-matched
          text_x: 50, //gallery image-matched
          text_y: 60.5 //gallery image-matched
        },
        'cot': {
          font_size: 6.25,
          text_x: 49.75,
          text_y: 59
        }
      },
      darker_text_variants: [
        'oatmeal-and-red',
      	'oatmeal-and-fawn',
        'white-and-pale-pink',
        'white-and-pale-blue',
        'white-and-pale-oatmeal',
      ]
	},
    'australian-garden': {
      orientation: 'landscape',
      font: 'Arial',
      sizes: {
        'bassinet': {
          font_size: 9.5,
          text_x: 49.75,
          text_y: 52.8
        },
        'cot': {
          font_size: 7.75,
          text_x: 48.5,
          text_y: 54.75
        }
      },
      darker_text_variants: [
      	'white-and-oatmeal',
        'white-and-pale-pink',
        'white-and-pale-blue',
      ]
	},
    'cuddly-koala': {
      orientation: 'landscape',
      font: 'Impact',
      sizes: {
        'bassinet': {
          font_size: 10,
          text_x: 50,
          text_y: 55.75
        },
        'cot': {
          font_size: 7,
          text_x: 51,
          text_y: 55.1
        }
      },
      darker_text_variants: ['mint-and-mid-grey']
	},
    'gingham': {
      orientation: 'landscape',
      font: 'bebasregular',
      sizes: {
        'bassinet': {
          font_size: 8,
          text_x: 50,
          text_y: 75.5
        },
        'cot': {
          font_size: 5.75,
          text_x: 50,
          text_y: 75.75
        }
      },
      darker_text_variants: []
	},
    'spotty': {
      orientation: 'landscape',
      font: 'quicksandregular',
      sizes: {
        'bassinet': {
          font_size: 6.75,
          text_x: 50,
          text_y: 82.25,
        },
        'cot': {
          font_size: 5.5,
          text_x: 50,
          text_y: 75
        }
      },
      darker_text_variants: []
	},
    'spring-garden': {
      orientation: 'landscape',
      font: 'quicksandregular',
      sizes: {
        'bassinet': {
          font_size: 9.5,
          text_x: 48,
          text_y: 55.5
        },
        'cot': {
          font_size: 7.5,
          text_x: 50,
          text_y: 54.5
        }
      },
      darker_text_variants: [
      	'white-and-oatmeal',
        'white-and-pale-pink',
        'white-and-pale-blue',
      ]
	},
    'under-the-sea': {
		name: 'Under the Sea',
		slug: 'under-the-sea',
		orientation: 'landscape',
		font: 'gooddogregular',
		sizes: {
			'bassinet': {
                font_size: 9,
				text_x: 50,
				text_y: 73.5
			},
			'cot': {
              	font_size: 6.6666666667,
				text_x: 45.75,
              text_y: 70.75
			}
		},
        darker_text_variants: []
		/*
        colors: {
			'aqua-and-white': {
				base_color: 'aqua',
				text_color: 'white'
			},
			'oatmeal-and-white': {
				base_color: 'oatmeal',
				text_color: 'white'
			},
			'pale-pink-and-white': {
				base_color: 'pale-pink',
				text_color: 'white'
			},
			'pale-blue-and-white': {
				base_color: 'pale-blue',
				text_color: 'white'
			},
			'navy-and-pale-blue': {
				base_color: 'navy',
				text_color: 'pale-blue'
			},
			'oatmeal-and-aqua': {
				base_color: 'oatmeal',
				text_color: 'aqua'
			}
		}
        */
      /*colorsx: [
          'aqua-and-white',
          'oatmeal-and-white',
          'pale-pink-and-white',
          'pale-blue-and-white',
          'navy-and-pale-blue',
          'oatmeal-and-aqua'
		]
        */
	},
    'classic-two-colour': {
      orientation: 'landscape',
      font: 'quintus-bold',
      sizes: {
        'bassinet': {
          font_size: 9.5,
          text_x: 48,
          text_y: 55.5
        },
        'cot': {
          font_size: 7.5,
          text_x: 50,
          // text_y: 54.5
          // text_y: 64.5
          text_y: 50
          // text_y: 60
        }
      },
      responsive_sizes: {
        bassinet: {
          Horizontal: {
            Quinty: {
              font_size: {
                // 11: 15.25,
                // 11: 16,
                11: 13,
                15: 9.25,
              },
              // letterSpacing: '-10%',
              // letterSpacing: '-0.05rem',
              letterSpacing: '-0.0rem',
              text_x: 49,
              text_x: 50,
              // text_y: 57,
              // text_y: 53
              text_y: 52.5,
              thicken_x: 0,
              thicken_y: 0
            },
            Bebe: {
              font_size: {
                11: 13,
                15: 9.5
              },
              thickenFactorX: .6,
              thickenFactorY: .5,
              letterSpacing: '0.02rem',
              text_x: 50,
              text_y: 53.5
            },
            Goodie: {
              font_size: {
                11: 14,
                15: 10
              },
              letterSpacing: '0.02rem',
              thickenFactorX: .6,
              thickenFactorY: .5,
              text_x: 50,
              text_y: 53
            },
            Sandy: {
              font_size: {
                11: 11,
                15: 7.75
              },
              letterSpacing: '0.01rem',
              text_x: 50,
              text_y: 51,
              thickenFactorX: 0,
              thickenFactorY: 0,
            }
          },
          Vertical: {
            Quinty: {
              font_size: {
                // 6: 27,
                6: 22.5,
                // 11: 15.25,
                11: 14.25,
                15: 10.75
              },
              letterSpacing: '-0.05rem',
              // text_x: 49,
              text_x: 50,
              text_y: 55
            },
            Bebe: {
              font_size: {
                // 6: 28,
                6: 18,
                // 11: 15,
                11: 13,
                // 15: 10.5
                15: 11
              },
              letterSpacing: '-0.03rem',
              text_x: 50,
              text_y: 55
            },
            Goodie: {
              font_size: {
                // 6: 28,
                // 11: 16,
                // 15: 11.5
                6: 18.5,
                11: 13.5,
                15: 11.5
              },
              letterSpacing: '-0.02rem',
              thickenFactorX: .6,
              thickenFactorY: .5,
              text_x: 50,
              text_y: 53
            },
            Sandy: {
              font_size: {
                6: 20,
                11: 12,
                15: 8.5,
                6: 14,
                11: 10,
                15: 8,
              },
              letterSpacing: '-0.00rem',
              thickenFactorX: .6,
              thickenFactorY: .5,
              text_x: 50,
              text_y: 53
            }
          }
        },
        cot: {
          Horizontal: {
            Quinty: {
              font_size: {
                11: 15.25,
                // 11: 16,
                15: 11
              },
              // letterSpacing: '-10%',
              // letterSpacing: '-0.05rem',
              letterSpacing: '-0.0rem',
              text_x: 49,
              text_x: 50,
              // text_y: 57,
              // text_y: 53
              text_y: 52.5,
              thicken_x: 0,
              thicken_y: 0
            },
            Bebe: {
              font_size: {
                11: 16,
                15: 9
              },
              letterSpacing: '-0.01rem',
              text_x: 50,
              text_y: 53.5
            },
            Goodie: {
              font_size: {
                11: 16,
                15: 9.25
              },
              letterSpacing: '0.01rem',
              text_x: 50,
              text_y: 53
            },
            Sandy: {
              font_size: {
                11: 11.75,
                15: 7.15
              },
              letterSpacing: '0.00rem',
              text_x: 50,
              text_y: 51,
              thickenFactorX: 0,
              thickenFactorY: 0,
            }
          },
          Vertical: {
            Quinty: {
              font_size: {
                6: 27,
                11: 15.25,
                15: 11
              },
              // letterSpacing: '-10%',
              letterSpacing: '-0.05rem',
              text_x: 49,
              text_x: 50,
              // text_y: 57,
              // text_y: 53
              text_y: 55
            },
            Bebe: {
              font_size: {
                6: 28,
                11: 15,
                15: 10.5
              },
              letterSpacing: '-0.03rem',
              text_x: 50,
              text_y: 55
            },
            Goodie: {
              font_size: {
                6: 28,
                11: 16,
                15: 11.5
              },
              letterSpacing: '-0.02rem',
              text_x: 50,
              text_y: 53
            },
            Sandy: {
              font_size: {
                6: 20,
                11: 12,
                15: 8.5
              },
              letterSpacing: '-0.00rem',
              thickenFactorX: .6,
              thickenFactorY: .5,
              text_x: 50,
              text_y: 53
            }
          }
        }
      },
      darker_text_variants: [
        'oatmeal-and-fawn',
        'pale-blue-and-navy',
        'oatmeal-and-forest',
        'oatmeal-and-charcoal',
        'pale-grey-and-charcoal',
        'oatmeal-and-french-navy',
      ]
	},
};